<div class="px-4 sm:px-6 md:px-8 py-8 md:py-12 max-w-[1400px] mx-auto min-h-screen">
  
  @if (!state.isWalletConnected()) {
    <div class="text-center py-20">
      <h2 class="text-xl font-bold text-white mb-4">Please connect your wallet to access Fiat Tokens.</h2>
      <p class="text-text-muted text-[13px]">We use your wallet signature as your identity to create a secure, isolated custodial wallet for you.</p>
    </div>
  } @else {
    <div class="card rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl shadow-xl overflow-hidden max-w-3xl mx-auto p-5 md:p-6">
      
      @if (isLoading) {
        <div class="flex justify-center items-center py-12">
          <svg class="animate-spin h-8 w-8 text-gold" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
        </div>
      } @else {
        
        <div class="mb-5 flex justify-between items-center bg-black/40 rounded-xl p-3 border border-white/[0.05]">
          <div>
            <div class="text-[11px] font-bold uppercase text-text-muted tracking-wider mb-0.5">Your Circle Stellar Address</div>
            <div class="font-mono text-[12px] text-[#20d489]">{{ circleWalletInfo?.address || 'Provisioning on first deposit...' }}</div>
          </div>
          <div>
            <div class="text-[11px] font-bold uppercase text-text-muted tracking-wider mb-0.5 text-right">Circle Wallet ID</div>
            <div class="font-mono text-[12px] text-white/50 text-right">{{ circleWalletInfo?.walletId || '---' }}</div>
          </div>
        </div>

        <div class="space-y-2">
          @for (token of supportedTokens; track token.symbol) {
            <div class="flex items-center justify-between p-3 bg-white/[0.02] hover:bg-white/[0.04] border border-white/[0.05] rounded-xl transition-colors gap-4">
              
              <div class="flex items-center gap-3 w-[150px]">
                <img [src]="token.logoUrl || token.logo || 'https://cryptologos.cc/logos/usd-coin-usdc-logo.png'" class="w-8 h-8 rounded-full shadow-md" [alt]="token.name">
                <div>
                  <div class="text-[14px] font-bold text-white leading-tight">{{ token.symbol }}</div>
                  <div class="text-[11px] font-semibold text-text-muted">{{ token.name }}</div>
                </div>
              </div>

              <div class="flex flex-col items-end">
                <div class="text-[10px] text-text-muted uppercase font-bold tracking-wider mb-0.5">Custodial Balance</div>
                <div class="text-[14px] font-black text-white">{{ getFiatBalanceFor(token.symbol) }}</div>
              </div>

              <div class="flex items-center gap-2">
                <button (click)="buyToken(token)" class="px-4 py-1.5 rounded-lg bg-[#20d489] text-black hover:bg-[#20d489]/90 text-[12px] font-extrabold transition-colors">
                  Buy
                </button>
                <button (click)="sellToken(token)" class="px-4 py-1.5 rounded-lg bg-red-500 text-white hover:bg-red-400 text-[12px] font-extrabold transition-colors">
                  Sell
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
